<div class="container">
  <div class="text-left">
      <div class="breadcrumb flat">
          <a [routerLink]="['/pos']">Home</a>
          <a href="#" class="active">Manage Orders List </a>
      </div>
  </div>
 
  <div class="container">
      <div class="card">
          <div class="card-header">
             
              <h4 class="mb-0 blue-t d-inline">Manage Order List </h4>
              <div class="float-right d-inline">
                  <button class="damke_siteBtn" type="button" id="NewTransaction"
                      [routerLink]="['/pos/order/new']" matTooltip="New Sale Transaction"> New Order </button>
              </div>
          </div> 
  
          <div class="card-body shadow right-img">
            
              <div>
                  <ngx-datatable #table class='bootstrap no-detail-row' [scrollbarH]="true"  [footerHeight]="50" [rowHeight]="'auto'"[columnMode]="'force'" [limit]="10" [rows]="rows" >
                    <ngx-datatable-column name="Action">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="edit"
                                [routerLink]="['/pos/order/view',{id : row.id}]"
                                data-toggle="tooltip" data-placement="top" title="View">
                                <img src="./assets/ViewDetails.svg">
                            </a>
                            <a class="edit" 
                            [routerLink]="['/pos/order/edit',{id : row.id}]" 
                            data-toggle="tooltip" data-placement="top" title="Edit">
                                <em class="fa-1x mr-2 fas fa-edit"></em>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    
                      <ngx-datatable-column name="AutoMatic Group Similar Itmes" [width]="200">
                          <ng-template let-row="row" ngx-datatable-cell-template>
                                <input type="checkbox"  [(ngModel)]="row.autoMaticGroupSimilarItmes" id="AutoMaticGroupSimilarItmes" name="AutoMaticGroupSimilarItmes">  
                            </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Allow Notes On Orders">
                          <ng-template let-row="row" ngx-datatable-cell-template> 
                                <input type="checkbox"  [(ngModel)]="row.allowNotesOnOrders" id="AllowNotesOnOrders" name="AllowNotesOnOrders">  
                            </ng-template>
                      </ngx-datatable-column>

                      <ngx-datatable-column name="Business Name" [width]="200">
                          <ng-template let-row="row" ngx-datatable-cell-template> {{row.posSubscriptionId}} </ng-template>

                      </ngx-datatable-column>
                     

                  </ngx-datatable>
              </div>
          </div>
      </div>
  </div>
</div>